import { render } from "./operationButton.vue?vue&type=template&id=6d283e5c&scoped=true"
import script from "./operationButton.vue?vue&type=script&lang=js"
export * from "./operationButton.vue?vue&type=script&lang=js"

import "./operationButton.vue?vue&type=style&index=0&id=6d283e5c&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d283e5c"]])

export default __exports__